import { Outlet } from "react-router-dom";

export function ProducerSetupLayout() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto w-full max-w-[720px] px-5 pt-10 pb-16">
        <Outlet />
      </div>
    </div>
  );
}
